import Vue from "vue";
import Component from "vue-class-component";
import { MethodService } from "@/utils/serviceModel";
import MaterialTypeNavigation from "@/businessComponents/mdl/materialTypeNavigation/materialTypeNavigation";

@Component({
  components: {
    MaterialTypeNavigation
  }
})
export default class MaterialService extends Vue {
  protected statistics = {};

  protected async fetchStatistics() {
    try {
      let res = await this.svStatistics.invokeAsyn({});
      if (res.data.isSuccess) {
        this.statistics = res.data.data;
      } else {
        this.statistics = {};
      }
    } catch (error) {
      this.statistics = {};
    }
  }

  protected getStaticValue(cd) {
    if (cd) {
      if (this.statistics[cd]) {
        let item = this.statistics[cd] as IndexObject;
        if (item) {
          return item.value;
        }
      }
    }
  }

  private svStatistics: MethodService = new MethodService(
    "mes.business.mdl.material.service",
    "MaterialService",
    "statistic_count"
  );
}
